<template>
  <div class="content-center">
      <div class="user-profile-page-container mt-5">
          <div class="account-header">
            <span class="account-setting locale-font">
                {{ $vuetify.lang.t('$vuetify.accountForm.accountSetting') }}
            </span>
            <div>
                <v-btn
                    outlined
                    class="mr-4"
                    width="180"
                    height="50"
                    color="primary"
                    @click="goToEdit()">
                    <span class="material-icons mr-2">edit</span>
                    {{ $vuetify.lang.t('$vuetify.accountForm.edit') }}
                </v-btn>
            </div>
          </div>
          <div class="mt-4 card-account">
              <div class="account-container">
                <div class="account-profile locale-font mb-4">
                    {{ $vuetify.lang.t('$vuetify.accountForm.profile') }}
                </div>
                <v-row>
                    <v-col cols="2">
                        <div class="account-picture-container">
                            <upload-image
                                ref="uploadImage"
                                :img="imgProfile(accountInfo.image)"
                                :isEditing="false"
                                :canDelete="false">
                            </upload-image>
                        </div>
                    </v-col>
                    <v-col cols="10">
                        <v-row>
                            <v-col cols="6">
                                <div class="text-header locale-font">
                                     {{ $vuetify.lang.t('$vuetify.accountForm.employeeID') }}
                                </div>
                                <div class="text-content">
                                    {{ checkStr(accountInfo.employee_id) }}
                                </div>
                            </v-col>
                            <v-col cols="6">
                                <div class="text-header locale-font">
                                    {{ $vuetify.lang.t('$vuetify.accountForm.phoneNumber') }}
                                </div>
                                <div class="text-content">
                                    {{ checkStr(accountInfo.phone_number) }}
                                </div>
                            </v-col>
                            <v-col cols="6">
                                <div class="text-header locale-font">
                                    {{ $vuetify.lang.t('$vuetify.accountForm.name') }}
                                </div>
                                <div class="text-content">
                                    {{ checkStr(accountInfo[`first_name_${this.$vuetify.lang.current}`]) }}
                                </div>
                            </v-col>
                            <v-col cols="6">
                                <div class="text-header locale-font">
                                    <div class="text-header locale-font">
                                        {{ $vuetify.lang.t('$vuetify.accountForm.surname') }}
                                    </div>
                                </div>
                                <div class="text-content">
                                    {{ checkStr(accountInfo[[`last_name_${this.$vuetify.lang.current}`]]) }}
                                </div>
                            </v-col>
                            <v-col cols="6">
                                <div class="text-header locale-font">
                                     {{ $vuetify.lang.t('$vuetify.accountForm.username') }}
                                </div>
                                <div class="text-content">
                                    {{ checkStr(accountInfo.username) }}
                                </div>
                            </v-col>
                            <v-col cols="6">
                                <div class="text-header locale-font">
                                    {{ $vuetify.lang.t('$vuetify.accountForm.emailAddress') }}
                                </div>
                                <div class="text-content">
                                    {{ checkStr(accountInfo.email) }}
                                </div>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
import UploadImage from '@/components/UploadImage'
import profileDefault from '@/assets/user_default.png'
export default {
    name: 'AccountInfo',

    components: {
        UploadImage
    },

    data () {
        return {
            accountInfo: {}
        }
    },

    methods: {
        imgProfile (img) {
            if (img) {
                return img
            } else {
                return profileDefault
            }
        },

        checkStr (str) {
            if (str) {
                return str
            } else {
                return '-'
            }
        },

        async getAccountInfo () {
            this.$store.dispatch('setLoading', true)
            const res = await this.axios.get('user/profile')

            if (res && res.data && res.data.status === 'ok') {
                this.accountInfo = res.data.data
                this.$store.dispatch('setLoading', false)
            } else {
                this.$store.dispatch('setLoading', false)
                this.$store.dispatch('setErrorModalShow', true)
                this.$store.dispatch('setErrorModalMsg', 'not fount user account')
            }
        },

        goToEdit () {
            this.$router.push({ name: 'AccountForm' }, () => {})
        }
    },

    async mounted () {
        await this.getAccountInfo()
    }

}
</script>

<style lang="scss" scoped>
.content-center {
    display: flex;
    justify-content: center;
}
.user-profile-page-container {
    max-width: 55rem;
}
.card-account {
    border-radius: 15px;
    box-shadow: 0 5px 25px 0 rgba(0, 0, 0, 0.05);
    background: #fff;
}
.text-header {
    font-size: 14px;
    color: #6c6c6c;
}
.text-content {
    font-size: 16px;
}
.account-setting {
    font-size: 32px;
    color: #131410;
}
.account-header {
    display: flex;
    justify-content: space-between;
}
.account-container {
    padding: 2.25rem;
}
.account-profile{
    font-size: 24px;
    max-width: 14%;
    display: flex;
    justify-content: center;
}
.account-picture-container {
    display: flex;
    justify-content: center;
}
</style>
